import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "./styles/variables.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./Resources/fonts/walsheim/GTWalsheimPro-Medium.ttf";
import "./Resources/fonts/walsheim/GTWalsheimPro-Regular.ttf";
import "./Resources/fonts/walsheim/GTWalsheimPro-Light.ttf";
import "./Resources/fonts/walsheim/GTWalsheimPro-Bold.ttf";
import { BrowserRouter } from "react-router-dom";
import { installGlobalImageFallback } from "./utils/globalImageFallback";

function getRouterBasename() {
  const configured = process.env.PUBLIC_URL || "";
  if (typeof window === "undefined") return configured;
  const host = window.location.hostname.toLowerCase();
  if (host === "gamee.fan" || host === "www.gamee.fan") {
    return "";
  }
  return configured || "/mg";
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={getRouterBasename()}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

requestAnimationFrame(() => {
  installGlobalImageFallback();
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
